/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Customer_PrepaidInputs */

const vi_order_customer_prepaid = /** @type {(inputs: Order_Customer_PrepaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách đang dư (trả trước)`)
};

/**

* @param {Order_Customer_PrepaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_customer_prepaid = /** @type {((inputs?: Order_Customer_PrepaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Customer_PrepaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_customer_prepaid(inputs)
});